var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticClass: "mr-3",
          attrs: { placeholder: "選擇層級" },
          on: { change: _vm.onSelect },
          model: {
            value: _vm.label,
            callback: function ($$v) {
              _vm.label = $$v
            },
            expression: "label",
          },
        },
        _vm._l(_vm.roleLabels, function (item) {
          return _c("el-option", {
            key: item.name,
            attrs: { label: item.name, value: item.value },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }